import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@context/frontend/common';
import { firstValueFrom } from 'rxjs';

export type ExternalViewRouteData = {
	organizationId: string;
	contentId: string;
	type: 'file' | 'folder';
	externalId: string;
};

@Injectable({ providedIn: 'root' })
export class ExternalViewLookupService {
	private readonly http = inject(HttpClient);
	private readonly apiUrl = inject(API_URL);

	lookupByExternalId(externalId: string): Promise<ExternalViewRouteData> {
		return firstValueFrom(
			this.http.get<ExternalViewRouteData>(
				`${this.apiUrl}/v1/users/external-share/lookup/${encodeURIComponent(externalId)}`,
			),
		);
	}
}
